'use strict';

import modalobsController from './modal_input/ddjjdetalle.modal.obs.controller.js';
import modalobsTemplate from './modal_input/ddjjdetalle.modal.obs.html';

import modalChangeController from './modal_input/changeTipo.modal.controller';
import modalChangeTemplate from './modal_input/changeTipo.modal.html';

class CertificacionProdController {
  constructor(NgTableParams, $log, Modal, Storage, DataService, $location, $sce) {
    'ngInject';
    this.NgTableParams = NgTableParams;
    this.$log = $log;
    this.Modal = Modal;
    this.Storage = Storage;
    this.DataService = DataService;
    this.$location = $location;
    this.$sce = $sce;
    this.cshb = true;
    this.ts = null;
  }

  $onInit() {
    this.titulo = 'Nombre de página';
    this.prod = this.Storage.get('cert_prod');
    this.getTipoSello(this.prod.tipoSello);
    this.nombres_insumos_nacionales = (this.prod.insumos.map(function (x) {
      return x.descripcion;
    })).join(", ");
    this.$log.log('Ingresandoooooooooooooooo', this.prod);
  }

  getTipoSello (tipoSello) {
    if (tipoSello === 1) {
      this.ts = 'ORO';
    } else if (tipoSello === 2) {
      this.ts = 'PLATA';
    } else {
      this.ts = 'BRONCE';
    }
  }

  verDDJJProducto() {
    this.Modal.pdf("certificacion_promueve/" + this.prod.unidad_productiva.id_unidad_productiva + "/certificacion/" + this.prod.id_producto + "/ddjj_pdf");
  }

  changeTipoSHB () {
    this.Modal.show({
      template: modalChangeTemplate,
      controller: modalChangeController,
      data: {
        titulo: "Cambiar a sello tipo PLATA",
        accion: "CAMBIAR",
        detalle_campo: "ingrese la justificación para la modificación del tipo de sello",
        id_producto: this.prod.id_producto,
        id_unidad_productiva: this.prod.fid_unidad_productiva,
        id_certificacion: this.prod.certificacion.id_certificacion
      },
      size: 'lg'
    });
  }

  volver() {
    this.$log.log('---Volvemos');
    this.$location.path('declaracionesJuradasPromueve');
  }

  aprobar() {
    this.Modal.confirm('¿Está seguro/a de aprobar la solicitud?', () => {
      this.$log.log('---Realizamos la aprobacion');
      var obj = {
        idCertificacion: this.prod.certificacion.id_certificacion,
        idProducto: this.prod.id_producto
      };

      // var ruta = 'certificacion_promueve/' + this.prod.fid_unidad_productiva + '/producto/evaluacion_solicitud';
      var ruta = 'certificacionesSHB/aprobar';
      this.DataService.put(ruta, obj)
        .then(response => {
          if (response) {
            this.$log.log('Respuesta***= ', response);
            this.$location.path('declaracionesJuradasPromueve');
          }
        });
    });
//    this.$location.path('aprobProductoPromueve');
  }

  isTipo(tipo) {
    return this.prod.certificacion.formulario.tipo===tipo;
  }

  rechazar() {
    this.Modal.show({
      template: modalobsTemplate,
      controller: modalobsController,
      data: {
        prefijo: 'rechazar',
        titulo: "Rechazar",
        accion: "RECHAZADO",
        detalle_campo: "Ingresar el motivo por el cual se rechaza la solicitud",
        id_producto: this.prod.id_producto,
        id_certificacion: this.prod.certificacion.id_certificacion,
        id_unidad_productiva: this.prod.fid_unidad_productiva
      },
      size: 'lg'
    });
  }

  observar()
  {
    this.Modal.show({
      template: modalobsTemplate,
      controller: modalobsController,
      data: {
        prefijo: 'observar',
        titulo: "Observar",
        accion: "OBSERVADO",
        detalle_campo: "INGRESAR OBSERVACIÓN",
        id_certificacion: this.prod.certificacion.id_certificacion,
        id_producto: this.prod.id_producto,
        id_unidad_productiva: this.prod.fid_unidad_productiva
      },
      size: 'lg'
    });
  }
}

export default CertificacionProdController;



// WEBPACK FOOTER //
// ./src/app/components/admin/promueve/certificacion/certificacion_prom.controller.js